import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_LIST = () => {
  return axiosIns.get("/departments");
};
